var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bd-layout-container-common no-tabs-bar"},[_c('div',{staticClass:"bd-layout-header fixed-header"},[_c('top-bar')],1),_c('div',{staticClass:"vab-main main-padding"},[_c('app-main')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }